module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-row card-content"
  }, [_c('img', {
    staticClass: "car_img",
    attrs: {
      "src": _vm.mixin_imgs[_vm.getOSSImg(_vm.carDetails.carImg)]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', {
    staticClass: "title-line"
  }, [_vm._v(_vm._s(_vm.carDetails.name))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row type-line",
    style: (_vm.$route.name == 'orderList' ? 'margin-bottom:0' : '')
  }, [_c('span', [_vm._v(_vm._s(_vm.carDetails.carTypeLevel))]), _vm._v(" "), (_vm.carDetails.carTypePower) ? _c('div', {
    staticClass: "section_3"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.carDetails.carTypePower))])]), _vm._v(" "), (_vm.current != 'order') ? _c('div', {
    staticClass: "flex-row price-line items-baseline"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticClass: "flex-row items-baseline"
  }, [_c('span', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("定金")]), _vm._v(" "), _c('span', {
    staticClass: "text_15 text-red"
  }, [_vm._v("¥")]), _vm._v(" "), _c('span', {
    staticClass: "text_16 text-red"
  }, [_vm._v(_vm._s(_vm.carDetails.presellPrice))])]), _vm._v(" "), (_vm.carDetails.markIcon) ? _c('span', {
    staticClass: "markIcon"
  }, [_vm._v("可退")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text_20"
  }, [_vm._v("指导价: " + _vm._s(_vm.carDetails.officialGuidePrice) + "万")])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-451d4245", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-451d4245","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/saleCar/_components/CarCard.vue
// module id = 279
// module chunks = 320 321